import { MathComponent } from "mathjax-react";
import { useState, useRef, useEffect } from "react";
import { Button, Modal } from "react-bootstrap";
import ReactQuill, { Quill } from "react-quill-new";
import { keyMap, labels } from "./keySymbols";
import './ReactQuillEditor.scss';
import katex from 'katex'
import { addStyles, EditableMathField, StaticMathField } from "react-mathquill";
import "react-quill-new/dist/quill.snow.css";
import { uploadLargeAssetAndAssesmble } from "../../utils/utils";

window.katex = katex;

Quill.imports["ui/icons"]["customButton"] = `<img class="math-btn-icon" src="${process.env.PUBLIC_URL}/static/images/mathedit.png" />`;

export default function ReactQuillEditor({ keyItem, reference, placeholder, value, onChange, disabled }) {
  const quillRef = useRef(null);
  const [modal, setmodal] = useState(false)
  const [latex, setLatex] = useState("")
  const [activeTab, setactiveTab] = useState(0)
  const [quillData, setquillData] = useState({
    position:0
  })

  addStyles()

  const showLatexModal = () => {
    setactiveTab(0)
    setLatex("")
    if(!modal) {
      const quill = reference.current[keyItem].getEditor();
      const range = quill.getSelection();
      let position = range ? range.index : 0;
      setquillData(prev=>{
        return({
          ...prev,
          position:position
        })
      })
    }
    setmodal(!modal)
  }

  useEffect(() => {
    let quill = null;
    
    const handlePaste = (e) => {
      const clipboard = e.clipboardData;
      if (!clipboard) return;

      // Block when pasting image files
      if (clipboard.files && clipboard.files.length) {
        for (let file of clipboard.files) {
          if (file.type.startsWith("image/")) {
            e.preventDefault();
            return;
          }
        }
      }
    };

    setTimeout(() => {
      quill = reference.current[keyItem].getEditor();

      quill.root.addEventListener("paste", handlePaste, true);
    }, 500);

    // const toolbar = quill.getModule("toolbar");

    // const customButton = document.createElement("button");
    // customButton.className = "ql-math"
    // customButton.style.display = "flex"
    // customButton.style.color = "black"
    // const imageElement = document.createElement("img");
    // imageElement.src = `${process.env.PUBLIC_URL}/static/images/mathedit.png`;
    // imageElement.alt = "Insert Symbol";
    // imageElement.style.width = "20px";
    // imageElement.style.height = "20px";
    // customButton.appendChild(imageElement);
    // customButton.onclick = () => {
    //   showLatexModal()
    // };

  // const formatContainer = toolbar.container.querySelector(".ql-formats");
  // if (formatContainer) {
  //   formatContainer.appendChild(customButton);
  // }

  return () => {
      // if (customButton && formatContainer) {
      //   formatContainer.removeChild(customButton);
      // }
      quill?.root.removeEventListener("paste", handlePaste, true);
    };
  }, [keyItem, reference]);

  // useEffect(() => {
  //     const quill = reference.current[keyItem].getEditor();
  //     console.log(quill,"quill")
  //   const toolbar = quill.getModule("toolbar");

  //   const customButton = document.createElement("button");
  //   customButton.style.display="flex"
  //   customButton.style.color="black"
  //   const imageElement = document.createElement("img");
  //   imageElement.src = `${process.env.PUBLIC_URL}/static/images/mathedit.png`;
  //   imageElement.alt = "Insert Symbol";
  //   imageElement.style.width = "20px";
  //   imageElement.style.height = "20px";
  //   customButton.appendChild(imageElement);
  //   const text = document.createElement("span");

  // //   customButton.appendChild(imageElement);

  // text.innerText ="▼";
  // customButton.appendChild(text);
  //   customButton.onclick = () => {
  //     const symbolContainer = document.querySelector(`.symbol-container_${keyItem}`);
  //     if (symbolContainer) {
  //         text.innerText =symbolContainer.style.display === "block" ? "▼" : "▲";
  //         symbolContainer.style.display = symbolContainer.style.display === "block" ? "none" : "block";
  //     }
  //     customButton.appendChild(text);
  //   };

  //   const formatContainer = toolbar.container.querySelector(".ql-formats");
  //   if (formatContainer) {
  //     formatContainer.appendChild(customButton);
  //   }

  //   const symbolContainer = document.createElement("div");
  //   symbolContainer.classList.add(`symbol-container_${keyItem}`);
  //   symbolContainer.style.display = "none";
  //   symbolContainer.style.marginTop="10px"
  //   symbols.forEach((item) => {
  //     const symbolButton = document.createElement("button");
  //     symbolButton.classList.add("symbol-button");
  //     symbolButton.textContent = item;
  //     symbolButton.style.fontWeight = "bold";
  //     symbolButton.style.fontSize = "16px";
  //     symbolButton.onclick = () => insertSymbol(item);
  //     symbolContainer.appendChild(symbolButton);
  //   });

  //   toolbar.container.appendChild(symbolContainer);

  //   return () => {
  //     if (customButton && formatContainer) {
  //       formatContainer.removeChild(customButton);
  //     }
  //     if (symbolContainer && formatContainer) {
  //       toolbar.container.removeChild(symbolContainer);
  //     }
  //   };
  // }, [keyItem, reference]);
  
  const handleTexInsert = () => { };

  const handleTex = (mathField) => {
    setLatex(mathField.latex());
  };

  const insertToQuill = () => {
    const quill = reference.current[keyItem].getEditor();
    const range = quill.getSelection();
    console.log(quillData.position,"position",value)
    quill.insertEmbed(quillData.position, 'formula', latex);
    quill.setSelection(quillData.position + 10)
  }

  const imageHandler = () => {
    const input = document.createElement('input');
    input.setAttribute('type', 'file');
    input.setAttribute('accept', 'image/*');
    input.click();

    input.onchange = async () => {
      const file = input.files[0];
      const asset = { name: file.name, size: file.size, file };

      const url = await uploadLargeAssetAndAssesmble(asset);
      const editor = quillRef.current.getEditor();
      const range = editor.getSelection();
      editor.insertEmbed(range.index, 'image', url);
    };
  };

  return (
    <div className={`react-quill-ui ${disabled ? "disabledbtn" : ""}`}>
      <ReactQuill
        theme="snow"
        ref={(el) => {
          reference.current[keyItem] = el;
          quillRef.current = el;
        }}
        modules={{
          toolbar: {
            container: [
              { size: [] }, { 'font': [] }, { 'color': [] }, { 'background': [] },
              'bold', 'italic', 'underline', 'image',
              { 'list': 'ordered' }, { 'list': 'bullet' },
              { 'indent': '-1' }, { 'indent': '+1' }, { 'script': 'sub' }, { 'script': 'super' },
              "customButton"
            ],
            handlers: {
              image: imageHandler,
              customButton: () => {
                showLatexModal();
              }
            }
          },
          clipboard: {
            matchVisual: false
          },
        }}
        placeholder={placeholder}
        value={value}  // Controlled value from parent
        onChange={onChange}  // Handle changes
      />
      <Modal centered show={modal} size={'lg'} animation={true}>
        <Modal.Header className="modal-header">
          <div>Formula</div>
          <div className="d-flex align-items-center justify-content-center flex-row mt-4">
            <Button variant="outline-dark btn-white mx-2" style={{ width: '120px' }} onClick={() => {
              setmodal(false)
              setLatex("")

            }}>Cancel</Button>
            <Button className="btn btn-primary mx-2" style={{ width: '120px' }} onClick={async () => {
              setmodal(false)
              insertToQuill()
            }}>Insert</Button>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className={`formula-modal w-100 ${latex != ""?"latexview":""}`}>
            <EditableMathField
              latex={latex}
              id="math-input"
              onChange={handleTex}
              onKeyUp={handleTexInsert}
              config={{  autoCommands:labels,autoOperatorNames: 'sin cos',
                }}
            />
            <div className="d-flex justify-content-around tabcont">
              {keyMap.map((keybox, keyboxindex) => (
                <button
                  key={"keyboxindex-" + keyboxindex}
                  className={`w-100 tab ${keyboxindex == activeTab ? "activeTab" : ""}`}
                  onClick={() => { setactiveTab(keyboxindex) }}
                >{keybox.tab}</button>
              ))}
            </div>
            <div className="flexbox">
              {keyMap[activeTab].keys.map((key, keyindex) => (
                <button key={"key-" + keyindex} className={"optionbtn"} onClick={() => {
                  let val = key.charCode ? key.charCode : key.mathCode
                  setLatex(prev => prev + val)

                }}>
                  {key.useJax ? <MathComponent tex={key.charCode ? key.charCode : key.mathCode} />
                    : <StaticMathField>{key.charCode ? key.charCode : key.mathCode}</StaticMathField>}
                </button>
              ))}</div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}
